"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LinkSpinner = {
  create: function create(el) {
    var child = el.childNodes[0];
    var childClassList = child.classList;

    if (child && (!childClassList || !childClassList.contains('js-text-container'))) {
      el.innerHTML = '<span class="js-text-container text-spinner-container spinner-text-transition">' + el.innerHTML + '</span>';
      var icon = document.createElement('i');
      icon.className = 'fa fa-spinner fa-spin order-spinner js-link-spinner-loader link-spinner hide';
      el.appendChild(icon);
    }

    el.start = function () {
      var text = el.getElementsByClassName('js-text-container');
      var icon = el.getElementsByClassName('js-link-spinner-loader');

      if (text[0]) {
        text[0].classList.add('hide-text');
      }

      if (icon[0]) {
        icon[0].classList.remove('hide');
      }
    };

    el.stop = function () {
      var text = el.getElementsByClassName('js-text-container');
      var icon = el.getElementsByClassName('js-link-spinner-loader');

      if (text[0]) {
        text[0].classList.remove('hide-text');
      }

      if (icon[0]) {
        icon[0].classList.add('hide');
      }
    };

    return el;
  }
};
var _default = LinkSpinner;
exports.default = _default;